import { render, staticRenderFns } from "./_base-link.vue?vue&type=template&id=d4d44af2&"
import script from "./_base-link.vue?vue&type=script&lang=js&"
export * from "./_base-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4d44af2')) {
      api.createRecord('d4d44af2', component.options)
    } else {
      api.reload('d4d44af2', component.options)
    }
    module.hot.accept("./_base-link.vue?vue&type=template&id=d4d44af2&", function () {
      api.rerender('d4d44af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-link.vue"
export default component.exports